var focusLight = {
  "&:focus": {
    "outline": "dashed 1px rgba(255, 255, 255, 0.92) !important",
    "outlineOffset": "3px"
  }
};

export { focusLight };
